import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <title>{props.title || 'Cancel'}</title>
      <g>
        <path d="M22.245 4.015c.313.313.313.826 0 1.139l-6.276 6.27c-.313.312-.313.826 0 1.14l6.273 6.272c.313.313.313.826 0 1.14l-2.285 2.277c-.314.312-.828.312-1.142 0l-6.271-6.271c-.313-.313-.828-.313-1.141 0l-6.276 6.267c-.313.313-.828.313-1.141 0l-2.282-2.28c-.313-.313-.313-.826 0-1.14l6.278-6.269c.313-.312.313-.826 0-1.14l-6.273-6.273c-.314-.313-.314-.827 0-1.14l2.284-2.278c.315-.312.828-.312 1.142.001l6.27 6.27c.314.314.828.314 1.141.001l6.276-6.267c.312-.312.826-.312 1.141 0l2.282 2.281z" />
      </g>
    </Icon>
  )
}
